export const ENTRYPOINT = process.env.REACT_APP_API_ENTRYPOINT;
export const GA_ID = process.env.GA_TRACKING_ID;
